import { Notification } from './Notification';
import { NotificationSubject } from './NotificationSubject';
import { NotificationSubjecttransaction } from './NotificationSubjecttransaction';

export class NotificationfullDataDto{
    notification:Notification;
    subject:NotificationSubject | NotificationSubjecttransaction ;
}